import * as Factory from 'factory.ts'
import faker from 'faker'

import { VendorTypes } from '@webapp/models/enums/Vendor'
import { DepartmentMock } from './department.factory'
import { PaymentTermMock } from './paymentTerm.factory'
import { ShippingMethodMock } from './shippingMethod.factory'
import { ShippingTermMock } from './shippingTerm.factory'
import { SimpleUserMock } from './user.factory'
import {
  type SimpleVendorRequest,
  type VendorRequest,
  type VendorRequestUser,
} from '../../models'

export const VendorRequestApproverMock =
  Factory.Sync.makeFactory<VendorRequestUser>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    email: Factory.each(() => faker.internet.email()),
    profile_image: Factory.each(() => faker.image.avatar()),
    department: DepartmentMock.build(),
    approval_delegatee: null,
  })

export const VendorRequestMock = Factory.Sync.makeFactory<VendorRequest>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.company.companyName()),
  address_line_one: Factory.each(() => faker.address.streetAddress()),
  address_line_two: Factory.each(() => faker.address.streetAddress()),
  postal_code: Factory.each(() => faker.address.zipCode()),
  city: Factory.each(() => faker.address.city()),
  state_province: Factory.each(() => faker.address.state()),
  country: Factory.each(() => faker.address.country()),
  phone_one: Factory.each(() => faker.phone.phoneNumber()),
  phone_two: '',
  fax: '',
  email: Factory.each(() => [faker.internet.email()]),
  contact: faker.name.findName(),
  url: faker.internet.url(),
  external_id: '',
  payment_term_ref: PaymentTermMock.build(),
  shipping_term_ref: ShippingTermMock.build(),
  payment_method_ref: null,
  shipping_method_ref: ShippingMethodMock.build(),
  type: VendorTypes.PREFERRED,
  reason: Factory.each(() => faker.random.word()),
  next_approver: VendorRequestApproverMock.build(),
  next_approver_choices: VendorRequestApproverMock.buildList(5),
  created_at: Factory.each(() => faker.date.past(10).toISOString()),
  requester: Factory.each(() => SimpleUserMock.build()),
  status: 1,
  permissions: { can_approve: false, can_edit: false, can_delete: false },
})

export const SimpleVendorRequestMock =
  Factory.Sync.makeFactory<SimpleVendorRequest>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.company.companyName()),
    requester: Factory.each(
      () => `${faker.name.firstName()} ${faker.name.lastName()}`
    ),
    submitted_date: Factory.each(() => faker.date.past(10).toISOString()),
    next_approver: Factory.each(
      () => `${faker.name.firstName()} ${faker.name.lastName()}`
    ),
    permissions: { can_approve: false, can_edit: false, can_delete: false },
  })
